import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { Column, ColumnKeys, JiraConfluenceGridEvents } from '../types';
import { WEB_COMPONENT_GRID_VIEW } from '../../../../../webcomponents.constants';
import { GridViewWebComponent } from '../../../../../grid/gridView';
import { translateFn } from '../../../../../utils/translator.helper';
import { AtlassianJiraConfluenceGridDataProvider } from '../dataProvider/AtlassianJiraConfluenceGridDataProvider';
import { WebComponentEvent } from '../../../../../framework/BaseWebComponentController';
import { actionsRenderer, confluenceCheckboxRenderer, jiraCheckboxRenderer } from './customGridRenderers';
import { GzDialogWebComponent } from '../../../../../ui/gzDialog';

export class AtlassianJiraConfluenceGridView extends BaseWebComponentView {

  public getDomElements(): void {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$gridView = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW) as GridViewWebComponent<Column, ColumnKeys>;
  }

  public buildView(data: any): void {
    if (!data) {
      this.dom.$wrapper.innerHTML = '';
      return;
    }

    this.buildGridView(data);
  }

  private buildGridView(data: any): void {
    const view = data.response.defaultViewProps;

    this.dom.$gridView.propertiesSet = false;
    this.dom.$gridView.dataProvider = new AtlassianJiraConfluenceGridDataProvider(this.dependencies);

    this.dom.$gridView.columnRenderers = {
      [ColumnKeys.ACTIONS]: actionsRenderer.bind(this),
      [ColumnKeys.CONFLUENCE]: confluenceCheckboxRenderer.bind(this),
      [ColumnKeys.JIRA]: jiraCheckboxRenderer.bind(this),
    };

    this.dom.$gridView.viewId = view.id;
    this.dom.$gridView.hideGridRefresh = true;
    this.dom.$gridView.allColumnDetails = data.response.allColumns;
    this.dom.$gridView.columns = view.displayedColumns;
    this.dom.$gridView.hasFilters = false;
    this.dom.$gridView.removeFilters = true;
    this.dom.$gridView.isCompactViewChecked = view.compactView;
    this.dom.$gridView.defaultViewProps = data.response.defaultViewProps;
    this.dom.$gridView.hasPagination = true;
    this.dom.$gridView.pageSize = view.pageSize;
    this.dom.$gridView.propertiesSet = true;

    this.dom.$gridView.customStrings = {
      noSearchResultsString: translateFn('No sensor has been added'),
    };

    if (this.dom.$gridView.injectDependencies) {
      this.dom.$gridView.injectDependencies(this.dependencies);
      this.dom.$gridView.start().then().catch(console.error);
    }
  }

  public onItemDelete(event: WebComponentEvent): void {
    const sensorId = event.target.getAttribute('data-internal-id') ?? '';
    this.deleteItem(sensorId);
  }

  public deleteItem(sensorId: string): void {
    const footerContent = document.createElement('div');
    footerContent.innerHTML = `
      <gz-button id="confirm" type="outline" color="primary">
        ${translateFn('Delete')}
      </gz-button>
      <gz-button id="cancel" type="outline" color="secondary" >
          ${translateFn('Cancel')}
      </gz-button>
  `;
    const confirmCallback = async () => {
      this.dom.$gridView.dataProvider.deleteItem(sensorId);
      await this.dom.$gridView.controller.handleGridItemsLoad();
    };

    const modalString = this.dependencies.translateFn('Delete the sensor? This action will remove it from the list.');
    const modalBodyString = `<p> ${modalString} </p>`;
    GzDialogWebComponent.computeCustomDialog(
      modalBodyString,
      footerContent.outerHTML,
      translateFn('Delete sensor'),
      null,
      confirmCallback,
      null,
      true
    );
  }
}
